import { ReflectionType } from '@shared/types';
import { updateTransactionReflectionInFirestore } from '@shared/services/transactionReflectionService';
import { logError } from '@/lib/log';

interface UseTransactionReflectionParams {
    setPendingReflections: React.Dispatch<React.SetStateAction<Map<string, ReflectionType>>>;
    uid?: string;
}

interface UseTransactionReflectionReturn {
    updateTransactionReflection: (id: string, reflection: ReflectionType) => Promise<boolean>;
}

export const useTransactionReflection = ({
    setPendingReflections,
    uid
}: UseTransactionReflectionParams): UseTransactionReflectionReturn => {
    const updateTransactionReflection = async (id: string, reflection: ReflectionType): Promise<boolean> => {
        // Optimistic update via pending overlay (survives Firestore sync overwrites)
        setPendingReflections(prev => new Map(prev).set(id, reflection));
        try {
            await updateTransactionReflectionInFirestore(id, reflection, uid);
            return true;
        } catch (error) {
            logError(error, { context: 'save_reflection', tags: { operation: 'save_reflection' } });
            // Rollback: remove from pending so Firestore data becomes canonical
            setPendingReflections(prev => {
                const next = new Map(prev);
                next.delete(id);
                return next;
            });
            return false;
        }
    };

    return {
        updateTransactionReflection
    };
};
